import React, { createContext, useContext, useState } from 'react';

const CultureContext = createContext();

export const CultureProvider = ({ children }) => {
  const [selectedCulture, setSelectedCulture] = useState('cafe');

  return (
    <CultureContext.Provider value={{ selectedCulture, setSelectedCulture }}>
      {children}
    </CultureContext.Provider>
  );
};

export const useCulture = () => {
  const context = useContext(CultureContext);
  if (!context) {
    throw new Error('useCulture must be used within a CultureProvider');
  }
  return context;
}; 